import React, { useState, useEffect } from "react";

import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { useSelector } from "react-redux";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Toast from "../container/Toast";
import ScrollToTop from "./ScrollToTop";
import PrivateRoute from "./PrivateRoute";
import HideFooter from "./HideFooter";
import Home from "../container/Home";
// import HideSupportModel from "./HideSupportModel";
// import SupportModal from "../container/SupportModal/SupportModal";
import {
  SPORTS_ROUTE,
  APP_ROUTES,
  CASINO_PRIVATE_ROUTES,
  CASINO_ROUTES,
  SIDEBAR_ROUTES,
  parentRoutes
} from "./routesList";
import { routesBuilder, suspenseWrapper } from "./sportsRoutesBuilder";
import MaintenanceWrapper from "../container/MaintenanceWrapper";
// import FallbackRoute from "../container/SportsBookNode/components/fallBackRoute";
// import PrivateIframeRoute from "./PrivateIframeRoute";
import IframeSportsBook from "../container/SportsBookNode/IframeSportsBook";
import NotASubscriber from "../components/NotASubscriber";
import SidebarContext from "../context/SidebarContext";
// import SportsBet from "../container/SportsBet";
// import CointBetFriends from "../components/User/CoinBetFriends";
// import Withdraw from "../components/User/Withdraw";
// import Deposit from "../components/User/Deposit";
// import Promotions from "../components/Promotions";
import NewSidebar from "../components/NewSidebar";
import MobileMenuPanel from "../components/MobMenuPanel";

const SIDEBAR_WIDTH_COLLAPSED = 64;
const SIDEBAR_WIDTH_EXPANDED = 64;

export const getApplicationRoutes = (routes) => {
  return routes.map((route) => (
    <Route
      exact
      path={route.path}
      key={route.path}
      element={suspenseWrapper(route.component)}
    />
  ));
};

const LayoutWrapper = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.authentication);
  const location = useLocation();
  const hideHeaderFooter = ["/login", "/user-login"].includes(
    location.pathname
  );

  const [expanded, setExpanded] = useState(true);
  const [isTablet, setIsTablet] = useState(
    typeof window !== "undefined" &&
      window.innerWidth <= 1024 &&
      window.innerWidth > 600
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= 600
  );

  const isSports =
    location.pathname.startsWith("/sports") ||
    location.pathname.startsWith("/game");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const tabletNow = width <= 1024 && width > 600;
      const mobileNow = width <= 600;

      setIsTablet(tabletNow);
      setIsMobile(mobileNow);

      if (tabletNow || mobileNow) {
        setExpanded(false);
      } else if (width > 1024) {
        setExpanded(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showSidebar = !isMobile && !isTablet;
  const sportsMarginLeft = showSidebar
    ? expanded
      ? SIDEBAR_WIDTH_EXPANDED
      : SIDEBAR_WIDTH_COLLAPSED
    : 0;
  const sidebarWidth = showSidebar ? SIDEBAR_WIDTH_COLLAPSED : 0;

  return (
    <SidebarContext.Provider
      value={{ expanded, setExpanded, isTablet, isMobile, sidebarWidth }}
    >
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
          background: "#101211"
        }}
      >
        {isLoggedIn &&
          (showSidebar ? (
            <NewSidebar expanded={expanded} setExpanded={setExpanded} />
          ) : (
            !isSports && <MobileMenuPanel />
          ))}

  <div
          style={{
            display: "flex",
            flex: 1,
            minHeight: "100vh",
            marginLeft: isSports ? sportsMarginLeft : sidebarWidth,
            flexDirection: "column",
            transition: "margin-left 0.25s ease",
            paddingTop: hideHeaderFooter ? 0 : "60px",
          }}
        >
          {!hideHeaderFooter && <Header />}
          <Toast />
          <div className={`mainContainer mainContainer-2 ${isSports ? "sports-container" : ""} ${expanded ? "sidebar-expanded" : "sidebar-collapsed"}`} style={{ flex: 1 }} >{children}</div>
          {!hideHeaderFooter && (
            <HideFooter>
              <Footer />
            </HideFooter>
          )}
        </div>
      </div>
    </SidebarContext.Provider>
  );
};

export const buildRouter = () => {
  const appRoutes = getApplicationRoutes(APP_ROUTES);
  const casinoPrivateRoutes = getApplicationRoutes(CASINO_PRIVATE_ROUTES);
  const sidebarRoutes = getApplicationRoutes(SIDEBAR_ROUTES);
  const casinoRoutes = getApplicationRoutes(CASINO_ROUTES);
  const [privateRoutes, nonPrivateRoutes] = routesBuilder(SPORTS_ROUTE, 1);
  const [privateRoutesV2, nonPrivateRoutesV2] = routesBuilder(SPORTS_ROUTE, 2);
  return (
    <>
      <ScrollToTop />
      <LayoutWrapper>
        <Routes>
          <Route path="/" key="Home" element={<Home />} />

          <Route element={<PrivateRoute />}>
            {appRoutes}
            <Route element={<MaintenanceWrapper sportsbook={true} />}>
              <Route
                path="/sports/*"
                key="sportsIframe"
                element={<IframeSportsBook />}
              />

              <Route
                path="/sportsbook"
                key="sports"
                //   element={suspenseWrapper(parentRoutes.sportsbook.component)}
                element={<NotASubscriber />}
              >
                {nonPrivateRoutes}
                <Route element={<NotASubscriber />}>{privateRoutes}</Route>
                <Route path="*" element={<NotASubscriber />} />
              </Route>
              <Route
                path="/sportsbookV2"
                key="sports"
                element={<NotASubscriber />}
              >
                {nonPrivateRoutesV2}
                <Route element={<NotASubscriber />}>{privateRoutesV2}</Route>
                <Route path="*" element={<NotASubscriber />} />
              </Route>
            </Route>

            <Route element={<PrivateRoute />}>
              <Route
                path="/user"
                key={"user"}
                element={suspenseWrapper(parentRoutes.sideBar.component)}
              >
                {sidebarRoutes}
              </Route>
            </Route>
            <Route element={<MaintenanceWrapper casino={true} />}>
              <Route element={<PrivateRoute />}>{casinoPrivateRoutes}</Route>
              <Route
                path="/casino"
                key={"casino"}
                element={suspenseWrapper(parentRoutes.lobbySubHeader.component)}
              >
                {casinoRoutes}
              </Route>
            </Route>
          </Route>
        </Routes>
      </LayoutWrapper>
    </>
  );
};

const appRouter = () => buildRouter();

export default appRouter;
